import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { getLanguages } from "../actions/languageAction";
import { loadUser, logout } from "../actions/authActions";
import { userOffline } from "../actions/firebaseAction";
import {
  Container,
  Nav,
  Navbar,
  NavbarToggler,
  NavItem,
  Collapse,
  Row,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VscChevronDown } from "react-icons/vsc";
import { MdLock } from "react-icons/md";
import Avatar from "@mui/material/Avatar";
import "./header.css";
import { useLocation } from 'react-router-dom';
import useConfig from "../hook/useConfig";
import { getLabelsName } from "../actions/lableAction"

const Header = (props) => {
  const { frontLabelsName } = props.label;
  const { getLabelsName } = props;
  const location = useLocation();
  const { borderRadius, locale, onChangeLocale } = useConfig();
  const [collapsed, setCollapsed] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const language = useSelector((state) => state.language);
  const { languages, loading } = language;

  const [open, setOpen] = useState(false);
  const [language1, setLanguage] = useState(locale);
  const [finLan, setFinLan] = useState(
    language?.languages.find(
      (item) => item.language_code === localStorage.getItem("i18nextFront")
    )?.image
  );
  const [localImage, setLocalImage] = useState("");

  useEffect(() => {
    if (localStorage.getItem("i18nextFront")) {
    } else {
      let found = language?.languages.find((element) => element.default === 1);
      setFinLan(found?.image);
      // localStorage.setItem("i18next",found?.language_code);
    }
  }, []);
  useEffect(() => {
    props.getLanguages();
  }, []);

  useEffect(() => {
    if (localStorage.getItem("i18nextFront")) {
      setLocalImage();
    }
  }, []);

  // let found = languages.find((element) => element.default === 1);

  const handleLanguageChange = (e, lng) => {
    setOpen(false);
    const prevLang = localStorage.getItem("i18nextFront");
    localStorage.setItem("prevLangFront", prevLang);
    localStorage.setItem("i18nextFront", lng?.language_code);
    setLanguage(lng?.language_code);

    setFinLan(lng?.image);
    getLabelsName()
    onChangeLocale(lng?.language_code);
    // window.location.reload(false);
    // i18next.changeLanguage(lng?.language_code);
  };
  useEffect(() => {
    setLanguage(locale);
  }, [locale]);
  const currentLanguageCode = languages?.filter(
    (data) => data?.default === 1
  )[0]?.image;

  const { auth } = props;
  const { isAuthenticated } = auth;

  const userName = props.auth.user;

  return (
    <header className="nav-shadow">
      <Row className="header-row">
        <Navbar expand="lg" container={false} className="ps-3 pe-3">
          {/* <NavbarBrand href="/"> */}
          <Link to="/">
            <img src={"assets/icons/logo.svg"} alt="logoo" />
          </Link>
          {/* </NavbarBrand> */}
          <NavbarToggler onClick={() => setCollapsed((prev) => !prev)} />
          <Collapse navbar isOpen={collapsed} className=" navbar-collapse11">
            {isAuthenticated ? (
              <Nav className="d-flex  ms-auto align-items-center pt-5" navbar>
                {/* <span >  */}
                <Link to="/my-profile">
                  <img
                    src={userName?.profile_pic}
                    className="logged-user-icons"
                  />
                </Link>
                {/* </span> */}
                <UncontrolledDropdown
                  nav
                  direction="down"
                  className="nav-link logged-user-pad"
                  inNavbar
                  onMouseOver={() => setDropdownOpen(true)}
                  onMouseLeave={() => setDropdownOpen(false)}
                  isOpen={dropdownOpen}
                // toggle={(prev)=>setDropdownOpen(!prev)}
                >
                  <DropdownToggle nav className="dropdown-hover-border">
                    <span className="me-1 logged-user-text">
                      {userName?.full_name}
                    </span>
                    <span>
                      <VscChevronDown className="logged-dropdown-icon" />
                    </span>
                  </DropdownToggle>
                  <DropdownMenu
                    className="dropdown-menu-style"
                    style={{ zIndex: "10000" }}
                  >
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/dashboard" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_dashboard")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_dashboard"
                              )[0]["value"] || "lbl_dashboard"
                              : "lbl_dashboard"
                            : "lbl_dashboard"}
                        </label>
                      </Link>
                    </DropdownItem>
                    {/* <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                    <Link to="/property-info" className="header-dropdown">
                      <label className="logged-user-text">My Properties </label>
                    </Link>
                  </DropdownItem> */}
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/my-profile" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_my_account"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_my_account"
                              )[0]["value"] || "lbl_my_account"
                              : "lbl_my_account"
                            : "lbl_my_account"}
                        </label>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/properties-watch" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_property_watch"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_property_watch"
                              )[0]["value"] || "lbl_property_watch"
                              : "lbl_property_watch"
                            : "lbl_property_watch"}
                        </label>
                      </Link>
                    </DropdownItem>

                    {/* <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                    <Link to="/tenant-list" className="header-dropdown">
                      <label className="logged-user-text">Tenant list</label>
                    </Link>
                  </DropdownItem> */}
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/renters-list" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_renters_list"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_renters_list"
                              )[0]["value"] || "lbl_renters_list"
                              : "lbl_renters_list"
                            : "lbl_renters_list"}
                        </label>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/change-password" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_change_password"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_change_password"
                              )[0]["value"] || "lbl_change_password"
                              : "lbl_change_password"
                            : "lbl_change_password"}
                        </label>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/subscription" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_subscription"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_subscription"
                              )[0]["value"] || "lbl_subscription"
                              : "lbl_subscription"
                            : "lbl_subscription"}
                        </label>
                      </Link>
                    </DropdownItem>
                    {/* <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                    <Link to="/property-watch" className="header-dropdown">
                      <label className="logged-user-text">Renters info</label>
                    </Link>
                  </DropdownItem> */}
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/chat-view" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_inbox")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_inbox"
                              )[0]["value"] || "lbl_inbox"
                              : "lbl_inbox"
                            : "lbl_inbox"}
                        </label>
                      </Link>
                    </DropdownItem>
                    {/* <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                    <Link to="/my-wishlist" className="header-dropdown">
                      <label className="logged-user-text">
                      {frontLabelsName
                ? frontLabelsName.filter((e) => e.key == "lbl_wishlist")
                    .length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_wishlist"
                    )[0]["value"] || "lbl_wishlist"
                  : "lbl_wishlist"
                : "lbl_wishlist"}
                      </label>
                    </Link>
                  // </DropdownItem> */}
                    {/* <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                    <Link to="/tenant-list" className="header-dropdown">
                      <label className="logged-user-text">Renters list</label>
                    </Link>
                  </DropdownItem> */}
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link
                        to="/favourite-properties"
                        className="header-dropdown"
                      >
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_favourites"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_favourites"
                              )[0]["value"] || "lbl_favourites"
                              : "lbl_favourites"
                            : "lbl_favourites"}
                        </label>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/hidden-properties" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_hidden_properties"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_hidden_properties"
                              )[0]["value"] || "lbl_hidden_properties"
                              : "lbl_hidden_properties"
                            : "lbl_hidden_properties"}
                        </label>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link
                        to="/applied-properties"
                        className="header-dropdown"
                      >
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_applied_for"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_applied_for"
                              )[0]["value"] || "lbl_applied_for"
                              : "lbl_applied_for"
                            : "lbl_applied_for"}
                          {/* <img src="assets/applyforaproperty.svg" alt="applied-proeprty" className="applied-property-img"/> */}
                        </label>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link to="/notification" className="header-dropdown">
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_notifications"
                            ).length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_notifications"
                              )[0]["value"] || "lbl_notifications"
                              : "lbl_notifications"
                            : "lbl_notifications"}
                        </label>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border2">
                      <Link
                        to="/login"
                        className="header-dropdown"
                        onClick={() => {
                          props.userOffline();
                          props.logout();
                        }}
                      >
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_logout")
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == "lbl_logout"
                              )[0]["value"] || "lbl_logout"
                              : "lbl_logout"
                            : "lbl_logout"}
                        </label>
                      </Link>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown
                  nav
                  direction="down"
                  className="logged-user-pad1"
                  onMouseOver={() => setDropdownOpen1(true)}
                  onMouseLeave={() => setDropdownOpen1(false)}
                  isOpen={dropdownOpen1}
                // toggle={(prev)=>setDropdownOpen1(!prev)}
                >
                  <DropdownToggle nav className="dropdown-hover-border">
                    <>
                      <img
                        src={finLan || currentLanguageCode}
                        alt="logged1"
                        className="logged-img-style"
                      />

                      <span className="drop-down-arrow ps-1">
                        <VscChevronDown className="logged-dropdown-icon" />
                      </span>
                    </>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-style">
                    {!loading &&
                      languages.map((data, index) => {
                        return (
                          <DropdownItem
                            // className="d-flex justify-content-between align-items-center dropdown-bottom-border"
                            onChange={(e) =>
                              setDropdownValue(data.language_code)
                            }
                            // onClick={handleLanguageChange}
                            onClick={(e) => handleLanguageChange(e, data)}
                            value={dropdownValue}
                            // selected={localStorage.getItem("i18nextFront")}
                            key={index}
                            className={`${dropdownValue ===
                              localStorage.getItem("i18nextFront")
                              ? "color-red"
                              : ""
                              }  d-flex justify-content-between align-items-center dropdown-bottom-border`}
                          >
                            <span className="d-flex align-items-center logo-position">
                              <Avatar
                                alt={data.language_name}
                                src={data.image}
                                className="lang-avtar-style"
                              />
                              <label className=" header-dropdown">
                                {data.language_name}
                              </label>
                            </span>
                          </DropdownItem>
                        );
                      })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            ) : (
              <Nav className="d-flex  ms-auto align-items-center" navbar>
                <UncontrolledDropdown
                  nav
                  direction="down"
                  className="nav-link1 logged-user-pad1 "
                  onMouseOver={() => setDropdownOpen(true)}
                  onMouseLeave={() => setDropdownOpen(false)}
                  isOpen={dropdownOpen}
                //toggle={(prev)=>setDropdownOpen(!prev)}
                //
                >
                  <div className='capsule-style '>
                    <DropdownToggle
                      nav
                      className="nav-style dropdown-hover-border py-1"
                    >

                      <span className="me-1 ps-1">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_registration")
                            .length > 0
                            ? frontLabelsName.filter(
                              (e) => e.key == "lbl_registration"
                            )[0]["value"] || "lbl_registration"
                            : "lbl_registration"
                          : "lbl_registration"}
                      </span>
                      <span>
                        <VscChevronDown className="logged-dropdown-icon" />
                      </span>

                    </DropdownToggle>
                  </div>
                  <DropdownMenu className="dropdown-menu-style">
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                      <div className={location.pathname == "/registration/type" ? "hover-effect-class-active" : "hover-effect-class"}>
                        <Link to="/registration/type" className="header-dropdown">
                          <label className="">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_renters")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_renters"
                                )[0]["value"] || "lbl_renters"
                                : "lbl_renters"
                              : "lbl_renters"}
                          </label>
                        </Link>
                      </div>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border1">
                      <div className={location.pathname == "/landlords/register-type" ? "hover-effect-class-active" : "hover-effect-class"}>
                        <Link
                          to="/landlords/register-type"
                          className="header-dropdown"
                        >

                          <label className="">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_landlords")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_landlords"
                                )[0]["value"] || "lbl_landlords"
                                : "lbl_landlords"
                              : "lbl_landlords"}
                          </label>
                        </Link>
                      </div>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>

                <UncontrolledDropdown
                  nav
                  direction="down"
                  className="nav-link logged-user-pad1 "
                  onMouseOver={() => setDropdownOpen1(true)}
                  onMouseLeave={() => setDropdownOpen1(false)}
                  isOpen={dropdownOpen1}
                // toggle={(prev)=>setDropdownOpen1(!prev)}
                >
                  <div className='capsule-style '>
                    <DropdownToggle
                      nav
                      className="nav-style dropdown-hover-border py-1 d-flex align-items-center"
                    >
                      <span className="d-flex align-items-center">
                        <MdLock className="nav-icon-style pe-1 " />
                      </span>
                      <span className="login-text">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_login")
                            .length > 0
                            ? frontLabelsName.filter((e) => e.key == "lbl_login")[0][
                            "value"
                            ] || "lbl_login"
                            : "lbl_login"
                          : "lbl_login"}
                      </span>{" "}
                      <span className="ps-1">
                        <VscChevronDown className="logged-dropdown-icon" />
                      </span>
                    </DropdownToggle>
                  </div>
                  <DropdownMenu className="dropdown-menu-style">
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                      <div className={location.pathname == "/login" ? "hover-effect-class-active" : "hover-effect-class"}>
                        <Link to="/login" className="header-dropdown">
                          <label className="">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_renters")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_renters"
                                )[0]["value"] || "lbl_renters"
                                : "lbl_renters"
                              : "lbl_renters"}
                          </label>
                        </Link>
                      </div>
                    </DropdownItem>
                    <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border1">
                      <div className={"hover-effect-class"}>
                        <a
                          href={process.env.REACT_APP_OWNER_URL}
                          target="_blank"
                          className="header-dropdown"
                        >
                          <label className="">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_landlords")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_landlords"
                                )[0]["value"] || "lbl_landlords"
                                : "lbl_landlords"
                              : "lbl_landlords"}
                          </label>
                        </a>
                      </div>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                <UncontrolledDropdown
                  nav
                  direction="down"
                  className="logged-user-pad1 margin-right-class"
                  onMouseOver={() => setDropdownOpen2(true)}
                  onMouseLeave={() => setDropdownOpen2(false)}
                  isOpen={dropdownOpen2}
                // toggle={(prev)=>setDropdownOpen2(!prev)} 
                >
                  <div className='capsule-style '>
                    <DropdownToggle nav className="dropdown-hover-border d-flex align-items-center nav-style py-1">

                      <img
                        src={finLan || currentLanguageCode}
                        alt=""
                        className="logged-img-style ps-1"
                      />

                      <span className="drop-down-arrow ps-1">
                        <VscChevronDown className="logged-dropdown-icon" />
                      </span>

                    </DropdownToggle>
                  </div>
                  <DropdownMenu className="dropdown-menu-style">
                    {
                      // !loading &&
                      languages.map((data, i) => {
                        return (
                          <DropdownItem
                            className="d-flex justify-content-between align-items-center dropdown-bottom-border"
                            value={data.language_code}
                            onClick={(e) => handleLanguageChange(e, data)}
                            key={i}
                          >
                            <div className={data.language_code ===
                              localStorage.getItem('i18nextFront') ? "hover-effect-class-active" : "hover-effect-class"}>
                              <span className="d-flex align-items-center logo-position">
                                <Avatar
                                  alt={data.language_name}
                                  src={data.image}
                                  className="lang-avtar-style"
                                />
                                <label className=" header-dropdown">
                                  {data.language_name}
                                </label>
                              </span>
                            </div>
                          </DropdownItem>
                        );
                      })
                    }
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            )}
          </Collapse>
        </Navbar>
      </Row>
    </header>
  );
};

const mapStateToProps = (state) => ({
  language: state.language,
  label: state.language,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getLanguages,
  loadUser,
  userOffline,
  logout,
  getLabelsName
})(Header);
